import { IconModel } from '../models/icon/icon.model';
import { IconStylingModel } from '../models/icon/icon-styling.model';

export const /** @type {?} */ IconTemplates = {
  defaultTemplate: {
    property: new IconModel({
      display: true,
      disable: false,
      name: 'cloud',
      size: '24px',
      value: 'icon'
    }),
    style : new IconStylingModel({
      container: {
        class: ''
      },
      icon: {
        class: 'cf-default-icon',
        themeColor: 'primary'
      }
    })
  },
  closeTemplate: {
    property: new IconModel({
      display: true,
      disable: false,
      name: 'fa-times-circle',
      size: '18px',
      value: 'close'
    }),
    style : new IconStylingModel({
      icon: {
        class: 'cf-close-icon'
      }
    })
  }
}
